/**
* Web Service handler to send updated Appointment status to the service
*
* @class UpdateAppointmentStatusWS
*/
function UpdateAppointmentStatusWS (parent) {
	var self = this;

	AbstractWS.apply( this, arguments );

	self.appointmentId					= ko.observable( null );
	self.method							= ko.observable( 'POST' );
	self.name							= 'UpdateAppointmentStatusWS';


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/employee/appointments/'+ self.appointmentId() +'/status';
	});



	/**
	* Overrides the AbstractWS method to prevent unintentional invocation.
	* To add an appointment, the sendTicket() method is invoked.
	*
	* @method doRequest
	* @return {UpdateAppointmentStatusWS}
	*/
	self.doRequest = function ( callback ) {
		// Return self (UpdateAppointmentStatusWS) to be chainable, for best practice
		return self;
	};


	/**
	* Sends an appointment id and new status to the API service
	*
	* @method update
	* @param {Integer} iAppointmentId Id of the appointment
	* @param {String} sStatus String to set appointment status to
	* @return {UpdateAppointmentStatusWS}
	*/
	self.update = function ( iAppointmentId, sStatus ) {
		// Block statuses that do not match the whitelist
		if ( ['PENDING','APPROVED','REJECTED','REJECTED_EXPLICITLY','SERVED_EARLY'].indexOf( sStatus.toUpperCase() ) == -1 ) {
			return self;
		}

		self.appointmentId( iAppointmentId );

		self.clearParams();

		self.addParam( 'status', sStatus.toUpperCase() );

		self.callback = function () {
			setTimeout( qcal.appointmentsWS.doRequest, 500 );
		}

		AbstractWS.prototype.doRequest.call(self);

		// Return self (UpdateAppointmentStatusWS) to be chainable, for best practice
		return self;
	};


	// Return self (UpdateAppointmentStatusWS) to be chainable, for best practice
	return self;
};

UpdateAppointmentStatusWS.prototype = AbstractWS.prototype;
UpdateAppointmentStatusWS.prototype.constructor = UpdateAppointmentStatusWS;
